// External libraries
import styled from 'styled-components';

// Zocdoc libraries
import { coral, grey25, navy } from '@zocdoc/branding/colors';
import { FontFamily } from '@zocdoc-frontend-common/styles-typography';

export const Wrapper = styled.div`
    position: relative;
`;

export const Textarea = styled.textarea`
    border: 1px solid ${grey25};
    box-sizing: border-box;
    color: ${navy};
    outline: 0;
    font: 15px/24px ${FontFamily.SharpSansMedium};
    padding: 14px 12px 12px;
    resize: none;
    width: 100%;

    &:focus {
        border-color: ${navy};
    }

    &[data-invalid] {
        border-color: ${coral};
    }
`;
